var map = {
	"./avatar-small.png": 1464,
	"./background_naturfagsmaraton.png": 1465,
	"./background_sciencedysten.png": 1466,
	"./close_black.png": 1467,
	"./empty.png": 1468,
	"./error.png": 1469,
	"./forside/forside_right_1.jpg": 1470,
	"./forside/forside_right_2.jpg": 1471,
	"./forside/grundfos-logo.jpg": 1472,
	"./forside/lundbeck.jpg": 1473,
	"./forside/novo-logo.jpg": 1474,
	"./forside/undervisningsministeriet.jpg": 1475,
	"./forside/villum-logo.jpg": 1476,
	"./hamburger.png": 1477,
	"./icons/success.svg": 878,
	"./lilla_pile.png": 1478,
	"./login-person.png": 1479,
	"./logo-grundfos.png": 1480,
	"./logo-lundbeck.png": 1481,
	"./logo-nordeafonden.png": 1482,
	"./logo-novonordiskfonden2.png": 1483,
	"./logo-novonordiskfonden_old.png": 1484,
	"./logo-undervisningsministeriet.png": 1485,
	"./logo-villum.png": 1486,
	"./logo_graa_pile.png": 1487,
	"./logos/logo 1.png": 1488,
	"./logos/logo-grundfos.png": 1489,
	"./logos/logo-lundbeck.png": 1490,
	"./logos/logo-novonordiskfonden.png": 1491,
	"./logos/logo-undervisningsministeriet.png": 1492,
	"./logos/logo-villumfonden.png": 1493,
	"./nfm-logo.png": 1494,
	"./nfm-stort-logo.png": 1495,
	"./nfm-tilmelding-login.png": 1496,
	"./placeholder.png": 647,
	"./placering.png": 1497,
	"./sd-logo-stort.png": 1498,
	"./sd-logo.png": 1499,
	"./spinner.gif": 1500
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1502;


//////////////////
// WEBPACK FOOTER
// ./src/content/img ^\.\/.*$
// module id = 1502
// module chunks = 0